import Api from "../../../utils/api";
import { API_URLS } from "../../../utils/api.urls";

export const fetchHomepage = async (): Promise<any> => {
  const data = await Api.get(API_URLS.BUYER.HOMEPAGE, []);
  return data;
};
